export default __webpack_public_path__ + "static/media/solar-panel-mobile.8ea041d3.jpeg";